<template>
    <div id="banner-01">
        <article class="banner">
            <div class="banner-logo-webstars"></div>
        </article>
    </div>
</template>
<script>
export default {
    name: 'HomeBannerHeader',
    data(){
        return {
            homeVideoBannerDisable: false,
        }
    },
    mounted(){
        this.homeVideoBannerDisable = process.env.VUE_APP_HOME_VIDEO_BANNER_DISABLE;
    },

}
</script>
<style scoped lang="scss">
@import '../../styles/variables';

section {
    text-align: left;
}

#banner-01{
    .banner{
        height: 330px;
        background-image: url(/img/2021/banner-03.jpg);
        background-position: center;
        background-repeat: no-repeat;
        position: relative;
        overflow: hidden;
        transition: filter 0.5s ease;
        border-top: 1px solid #C4022F;
        border-bottom: 1px solid #C4022F;
        &.loading {
            filter: blur(20px);
            background-color: var(--pallete_secondary_color);
        }
        @media(max-width: 960px){
            height: 200px;
            background-size: auto 200px;
        }

        //.banner-logo-webstars{
        //    width: 100%;
        //    height: 100%;
        //    background-image: url(/img/2021/logo-webstars_424x119.webp);
        //    background-position: center;
        //    background-repeat: no-repeat;
        //    @media(max-width: 960px){
        //        background-size: 70%;
        //    }
        //}
    }
}
</style>
